import { render, staticRenderFns } from "./BusinessAcceptForm.vue?vue&type=template&id=6acdfe30&"
import script from "./BusinessAcceptForm.vue?vue&type=script&lang=js&"
export * from "./BusinessAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports